module.exports = __webpack_public_path__ + "img/pr-10.992616e0.png";